import {HostBinding, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {StyleManagerService} from "./style-manager.service";
import {Option} from "../interfaces/theme-option.interface";
import {Observable} from "rxjs";
import {NGXLogger} from "ngx-logger";
import {OverlayContainer} from "@angular/cdk/overlay";
import {CustomFavicon} from "../favicon.config";
import {NgxFaviconService} from "ngx-favicon";
import {ThemeType} from "../../signup/models/theme-type";
import {BASK_BRAND_NAME, BASK_URL_CHECK, TCB_BRAND_NAME} from "../../shared/constants";
import {MainLayoutService} from "../../shared/services/main-layout.service";
import {CoreService} from "../../shared/services/core.service";
import {BrandType} from "../../signup/models/brand-type";

@Injectable()
export class ThemeService {
  activeTheme : any;
  @HostBinding('class') activeThemeCssClass: string

  constructor(
    private http: HttpClient,
    private styleManager: StyleManagerService,
    private logger: NGXLogger,
    private overlayContainer: OverlayContainer,
    private ngxFaviconService: NgxFaviconService<CustomFavicon>,
    private mainLayoutService: MainLayoutService,
    private coreService: CoreService
  ) {
    this.activeThemeCssClass = "";
  }

  getThemeOptions(): Observable<Array<Option>> {
    return this.http.get<Array<Option>>("assets/theme-options.json");
  }

  /**
   * Set the theme to the name of the theme passed in.
   * @param themeToSet Name of theme.
   */
  set(themeToSet: any) {
    if (themeToSet != null) {
      this.styleManager.setStyle(
        "theme",
        `assets/theme/${themeToSet}.css`
      );
      console.log("setting style to " + themeToSet);
    }
  }

  /**
   * Set a Default theme based on the entry url.
   */
  applyBrandTheming(type: ThemeType) {
    this.set(type);

    switch (type) {
      case ThemeType.BaskLoading:
      case ThemeType.Bask:
        this.coreService.setBrand(BASK_BRAND_NAME);
        this.ngxFaviconService.setCustomFavicon(CustomFavicon.FAVICON_BASK);
        break;

      default:
        this.coreService.setBrand(TCB_BRAND_NAME);
        this.ngxFaviconService.setCustomFavicon(CustomFavicon.FAVICON_TCB);
        break;
    }
  }

  setThemeByBrandId(brandId: number) {
    let themeType: ThemeType = brandId === BrandType.BaskBank ? ThemeType.Bask : ThemeType.Tcb;

    this.applyBrandTheming(themeType);
  }

  /**
   * Set the theme based on URL and loading
   * @param isLoading
   */
  setBaseTheme(isLoading: boolean = false) {
    let themeType: ThemeType = isLoading ? ThemeType.TcbLoading : ThemeType.Tcb;

    if(location.href.includes(BASK_URL_CHECK)){
      themeType = isLoading ? ThemeType.BaskLoading : ThemeType.Bask;
    }

    this.applyBrandTheming(themeType);
    this.mainLayoutService.setPageTitle();
  }
}
